import { UserRegistration } from '../../models/userRegistration';
import {Component, HostListener, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ManagementService } from 'src/app/services/management.service';
import { signUp } from '@aws-amplify/auth';
import {NavBarComponent} from "../../nav-bar/nav-bar.component";
import {BaseService} from "../../services/base.service";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RegistrationComponent implements OnInit {


    public termsAndConditionsUrl = environment.termsAndConditionsUrl;
    public privacyPolicyUrl = environment.privacyPolicyUrl;

    public successfullyRegistered = false;
    public setBackgroundActive = false;
    showPasswordToggles = {
        showPassword: false,
        showConfirmPassword: false
    }
    themeName: string = environment.theme.title;
    isMobile: boolean = false;


    public registrationForm: FormGroup;
    public environment = environment;
    
    constructor(
        public router: Router,
        private snackBarInvalidForm: MatSnackBar,
        private snackBarTnCAccept: MatSnackBar,
        private formBuilder: FormBuilder,
        public projectTitle: Title,
        public managementService: ManagementService,
        private nav: NavBarComponent,
        private baseService: BaseService,
    ) {
        this.registrationForm = this.formBuilder.group({
            firstName: [null, Validators.required],
            lastName: [null, Validators.required],
            email: [null, [Validators.required, Validators.email]],
            cellNumber: [null, Validators.required],
            companyName: [null, Validators.required],
            password: [null, [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=\S+$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).+$/)]],
            confirmPassword: [null, Validators.required],
        }, {validators: this.baseService.matchValidator('password', 'confirmPassword') });
    }

    // tslint:disable-next-line:typedef
    toggleCheck: string;
    checked = false;

    get formControls() {
        return this.registrationForm.controls;
    }

    async submitRegistrationForm() {
        // const userRegistrationForm = {
        //     name: this.registrationForm.value.firstName,
        //     surname: this.registrationForm.value.lastName,
        //     email: this.registrationForm.value.email,
        //     phone: this.registrationForm.value.cellNumber,
        //     company: this.registrationForm.value.companyName,
        //     termsAndConditionsAndPrivacyPolicyAccepted: this.registrationForm.value.termsAndConditionsAndPrivacyPolicyAccepted,
        // };
        this.registrationForm.markAllAsTouched();
        if (this.registrationForm.invalid) {
            this.snackBarInvalidForm.open('Please ensure all required fields have been completed.', '', {
                duration: 3000
            });
        } else if (this.registrationForm.valid) {
            this.nav.toggleLoading(true);
            await signUp({
                username: this.registrationForm.value.email.toLowerCase(),
                password: this.registrationForm.value.password,
                options: {
                    userAttributes: {
                        email: this.registrationForm.value.email.toLowerCase(),
                        phone_number: '+27' + this.registrationForm.value.cellNumber,
                        name: this.registrationForm.value.firstName,
                        family_name: this.registrationForm.value.lastName,
                        "custom:company_name": this.registrationForm.value.companyName
                    },
                }
            }).then(() => {
                this.nav.toggleLoading(false);
                this.successfullyRegistered = true;
            }).catch(error => {
                this.nav.toggleLoading(false);
                this.successfullyRegistered = false;
                this.snackBarInvalidForm.open(error.message, '', {
                    duration: 3000
                });
            })
            // this.managementService.registerUser(userRegistrationForm).subscribe((result) => {
            //         this.successfullyRegistered = true;
            //     },
            //     (error) => {
            //         //
            //     });
        }
    }

    toggleChanged() {
        this.checked = !this.checked;
        this.toggleCheck = this.toggleCheck === '' ? 'checked' : '';
    }

    ngOnInit(): void {
        sessionStorage.clear();
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.isMobile = window.innerWidth <= 1024;
    }

    getLogo(): string{
        return environment?.theme?.logo;
  }

    getLogoStyling(): any{
       return environment?.theme?.logoStyling;
  }

    setBackground(): any{
    return environment?.theme?.background || {};
  }
}
